import ExcerptionEditModal from './excerption-edit-modal'

export default ExcerptionEditModal
